import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Plus, Wrench } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import { getSparePartTypes, createSparePartType } from "@/integrations/supabase/inventory-services";
import { useAuth } from "@/context/AuthContext";
import AddSparePartTypeModal from "./AddSparePartTypeModal";

const SparePartTypesView = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const { profile } = useAuth();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const { data: sparePartTypes, isLoading } = useQuery({
    queryKey: ['spare-part-types'],
    queryFn: getSparePartTypes,
  });

  const isSuperAdmin = profile?.role === 'super_admin';

  if (isLoading) {
    return <div className="text-center py-4">Cargando tipos de repuestos...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Catálogo de Repuestos</h3>
        {isSuperAdmin && (
          <Button onClick={() => setShowAddModal(true)} className="flex items-center gap-2">
            <Plus className="h-4 w-4" />
            Nuevo Tipo
          </Button>
        )}
      </div>

      <div className="grid gap-2">
        {sparePartTypes?.map((type) => (
          <Card key={type.id}>
            <CardHeader className="pb-2 pt-2">
              <div className="flex items-center gap-2">
                <Wrench className="h-5 w-5 text-bike-600" />
                <div>
                  <CardTitle className="text-lg">{type.name}</CardTitle>
                  {type.description && (
                    <p className="text-sm text-gray-600">{type.description}</p>
                  )}
                </div>
              </div>
            </CardHeader>
          </Card>
        ))}

        {sparePartTypes?.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No hay tipos de repuestos registrados
          </div>
        )}
      </div>

      <AddSparePartTypeModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={() => {
          queryClient.invalidateQueries({ queryKey: ['spare-part-types'] });
          setShowAddModal(false);
        }}
      />
    </div>
  );
};

export default SparePartTypesView;
